var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8827 12.0867C14.8827 11.886 14.7321 11.7324 14.5352 11.7324C14.3383 11.7324 14.1877 11.886 14.1877 12.0867C14.1877 13.4686 13.0872 14.5906 11.7319 14.5906C10.3766 14.5906 9.27609 13.4686 9.27609 12.0867C9.27609 11.886 9.1255 11.7324 8.92857 11.7324C8.73165 11.7324 8.58105 11.886 8.58105 12.0867C8.58105 13.7285 9.78578 15.1103 11.3844 15.2875L11.3844 16.2324L10.1217 16.2324C9.92479 16.2324 9.7742 16.3859 9.7742 16.5867C9.7742 16.7875 9.92479 16.941 10.1217 16.941L13.342 16.941C13.539 16.941 13.6896 16.7875 13.6896 16.5867C13.6896 16.3859 13.539 16.2324 13.342 16.2324L12.0794 16.2324L12.0794 15.2875C13.678 15.1103 14.8827 13.7285 14.8827 12.0867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7314 6.90186C10.6657 6.90186 9.79687 7.78767 9.79687 8.87427L9.79687 12.075C9.79687 13.1734 10.6657 14.0474 11.7314 14.0592C12.7971 14.0592 13.6659 13.1734 13.6659 12.0868L13.6659 8.87427C13.6659 7.78767 12.7971 6.90186 11.7314 6.90186Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.636367,
    height: 10.5647,
    rx: 0.318183,
    transform: "matrix(0.700214 0.713933 -0.700214 0.713933 15.2402 7.81812)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordOff);
export default __webpack_public_path__ + "static/media/recordOff.d9a91e8e62afc3bd6c142e25ebe850e0.svg";
export { ForwardRef as ReactComponent };